import React from 'react';
import { Check, Gift } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function ValueBreakdown() {
  const {
    t
  } = useLanguage();
  return <section className="w-full py-16 md:py-24 bg-[#F5F1E8]" data-id="element-539">
      <div className="max-w-4xl mx-auto px-6 md:px-12" data-id="element-540">
        <h2 className="text-4xl md:text-5xl text-[#3E2723] mb-12 text-center" data-id="element-541">
          {t('valueBreakdown.title')}
        </h2>

        <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-[#3E2723]/10" data-id="element-542">
          <div className="bg-[#3E2723] text-white p-6 text-center" data-id="element-543">
            <h3 className="text-2xl font-bold" data-id="element-544">{t('valueBreakdown.bundle')}</h3>
          </div>

          <div className="p-6 md:p-8 space-y-4" data-id="element-545">
            <div className="flex items-center justify-between py-3 border-b border-[#3E2723]/10" data-id="element-546">
              <div className="flex items-center gap-3" data-id="element-547">
                <Check className="w-5 h-5 text-[#14B8A6]" data-id="element-548" />
                <span className="text-lg text-[#3E2723] font-medium" data-id="element-549">
                  {t('valueBreakdown.item1')}
                </span>
              </div>
              <span className="text-lg text-[#3E2723]/60 line-through" data-id="element-550">
                $49.00
              </span>
            </div>

            <div className="flex items-center justify-between py-3 border-b border-[#3E2723]/10" data-id="element-551">
              <div className="flex items-center gap-3" data-id="element-552">
                <Check className="w-5 h-5 text-[#14B8A6]" data-id="element-553" />
                <span className="text-lg text-[#3E2723] font-medium" data-id="element-554">
                  {t('valueBreakdown.item2')}
                </span>
              </div>
              <span className="text-lg text-[#14B8A6] font-bold" data-id="element-555">
                {t('valueBreakdown.included')}
              </span>
            </div>

            <div className="flex items-center justify-between py-3 border-b border-[#3E2723]/10" data-id="element-556">
              <div className="flex items-center gap-3" data-id="element-557">
                <Check className="w-5 h-5 text-[#14B8A6]" data-id="element-558" />
                <span className="text-lg text-[#3E2723] font-medium" data-id="element-559">
                  {t('valueBreakdown.item3')}
                </span>
              </div>
              <span className="text-lg text-[#3E2723]/60 line-through" data-id="element-560">
                $29.00
              </span>
            </div>

            <div className="flex items-center justify-between py-3 border-b border-[#3E2723]/10" data-id="element-561">
              <div className="flex items-center gap-3" data-id="element-562">
                <Check className="w-5 h-5 text-[#14B8A6]" data-id="element-563" />
                <span className="text-lg text-[#3E2723] font-medium" data-id="element-564">
                  {t('valueBreakdown.item4')}
                </span>
              </div>
              <span className="text-lg text-[#3E2723]/60 line-through" data-id="element-565">
                $19.00
              </span>
            </div>

            <div className="flex items-center justify-between py-3 border-b border-[#3E2723]/10" data-id="element-566">
              <div className="flex items-center gap-3" data-id="element-567">
                <Check className="w-5 h-5 text-[#14B8A6]" data-id="element-568" />
                <span className="text-lg text-[#3E2723] font-medium" data-id="element-569">
                  {t('valueBreakdown.item5')}
                </span>
              </div>
              <span className="text-lg text-[#3E2723]/60 line-through" data-id="element-570">
                $19.00
              </span>
            </div>

            <div className="flex items-center justify-between py-3 border-b border-[#3E2723]/10 bg-[#EC4899]/5 -mx-6 md:-mx-8 px-6 md:px-8" data-id="element-571">
              <div className="flex items-center gap-3" data-id="element-572">
                <Gift className="w-5 h-5 text-[#EC4899]" data-id="element-573" />
                <span className="text-lg text-[#3E2723] font-bold" data-id="element-574">
                  {t('valueBreakdown.bonus1')}
                </span>
              </div>
              <span className="text-lg text-[#3E2723]/60 line-through" data-id="element-575">
                $13.00
              </span>
            </div>

            <div className="flex items-center justify-between py-3 border-b border-[#3E2723]/10 bg-[#EC4899]/5 -mx-6 md:-mx-8 px-6 md:px-8" data-id="element-576">
              <div className="flex items-start gap-3 pr-2" data-id="element-577">
                <Gift className="w-5 h-5 text-[#EC4899] flex-shrink-0 mt-1" data-id="element-578" />
                <div data-id="element-579">
                  <span className="text-lg text-[#3E2723] font-bold block" data-id="element-580">
                    {t('valueBreakdown.bonus2')}
                  </span>
                  <span className="text-xs text-[#3E2723]/60 italic" data-id="element-581">
                    {t('valueBreakdown.bonus2Desc')}
                  </span>
                </div>
              </div>
              <span className="text-lg text-[#EC4899] font-bold whitespace-nowrap" data-id="element-582">
                {t('valueBreakdown.free')}
              </span>
            </div>

            <div className="flex items-center justify-between py-3 bg-[#EC4899]/5 -mx-6 md:-mx-8 px-6 md:px-8 pb-4" data-id="element-583">
              <div className="flex items-start gap-3 pr-2" data-id="element-584">
                <Gift className="w-5 h-5 text-[#EC4899] flex-shrink-0 mt-1" data-id="element-585" />
                <div data-id="element-586">
                  <span className="text-lg text-[#3E2723] font-bold block" data-id="element-587">
                    {t('valueBreakdown.bonus3')}
                  </span>
                  <span className="text-xs text-[#3E2723]/60 italic" data-id="element-588">
                    {t('valueBreakdown.bonus3Desc')}
                  </span>
                </div>
              </div>
              <span className="text-lg text-[#EC4899] font-bold whitespace-nowrap" data-id="element-589">
                {t('valueBreakdown.free')}
              </span>
            </div>
          </div>

          <div className="bg-[#FBF7F0] p-6 md:p-8 border-t-2 border-dashed border-[#3E2723]/20" data-id="element-590">
            <div className="flex justify-between items-end mb-2" data-id="element-591">
              <span className="text-xl text-[#3E2723] font-medium" data-id="element-592">
                {t('valueBreakdown.totalValue')}
              </span>
              <span className="text-3xl text-[#3E2723]/50 line-through font-bold" data-id="element-593">
                $129.00
              </span>
            </div>
            <div className="flex justify-between items-end" data-id="element-594">
              <span className="text-2xl text-[#3E2723] font-bold" data-id="element-595">
                {t('valueBreakdown.todayPrice')}
              </span>
              <span className="text-5xl md:text-6xl text-[#C2410C] font-extrabold" data-id="element-596">
                $6.39
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}